"use client"

import React, { useState, useEffect } from "react"
import { apiLiveScore, apiPayment } from "api"
import { usePathname } from "next/navigation"
import FlyButton from "components/FlyButton"
// import PopupButton from "components/PopupButton"
import useStore from "components/ui/Context"

const EventButton = () => {
  const pathname = usePathname()

  // const [openPopup, setOpenPopup] = useState(false)
  const [dataEventState, setDataEventState] = useState(null)
  // const [dataSubscriptionState, setDataSubscriptionState] = useState(null)
  const { userInfo, toggleModalLogin, setDataEvent, setIsRedirectEvent, setDataSubscription } = useStore()

  // function onChangeModal() {
  //   toggleModalLogin()
  // }
  // const getMySubscription = async () => {
  //   try {
  //     const { data, success } = await apiPayment.getMySub()
  //     if (success) {
  //       setDataSubscription(data)
  //       setDataSubscriptionState(data)
  //     } else {
  //       console.error("Failed to fetch events")
  //     }
  //   } catch (error) {
  //     console.error("Error fetching events:", error)
  //   }
  // }
  const getEvents = async () => {
    try {
      const { data, success } = await apiLiveScore.getEvents()
      if (success) {
        setDataEvent(data?.lucky_wheel)
        setDataEventState(data?.lucky_wheel)
      } else {
        console.error("Failed to fetch events")
      }
    } catch (error) {
      console.error("Error fetching events:", error)
    }
  }
  useEffect(() => {
    getEvents()
    // if (userInfo && userInfo.id) {
    //   getMySubscription()
    // }
  }, [userInfo])

  const isVisible = pathname === "/"
  if (!isVisible) return null

  return (
    <>
      <FlyButton dataEventState={dataEventState} />
      {/* <PopupButton
        setIsRedirectEvent={setIsRedirectEvent}
        dataSubscriptionState={dataSubscriptionState}
        dataEventState={dataEventState}
        userInfo={userInfo}
        onChangeModal={onChangeModal}
        openPopup={openPopup}
        setOpenPopup={setOpenPopup}
      /> */}
    </>
  )
}

export default EventButton
